(() => {
  if (window.tbsDeferredQuickview) return;
  window.tbsDeferredQuickview = true;
  const requests = new WeakMap();
  document.addEventListener('click', async event => {
    const trigger = event.target.closest?.('[data-aie-quickview-button]');
    const root = trigger?.closest('[data-tbs-quickview-section]');
    const target = trigger?.getAttribute('data-aie-quickview-target');
    if (!root || !target || root.querySelector('#' + CSS.escape(target))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (trigger.getAttribute('aria-busy') === 'true') return;
    const url = new URL(location.href);
    url.hash = '';
    url.searchParams.set('section_id', root.dataset.tbsQuickviewSection);
    if (root.dataset.tbsQuickviewKind !== 'carousel') {
      const page = Number(target.split('-').at(-2));
      if (Number.isInteger(page) && page > 0) url.searchParams.set('page', String(page));
    }
    let cache = requests.get(root);
    if (!cache) { cache = new Map(); requests.set(root, cache); }
    const cacheKey = url.toString();
    trigger.setAttribute('aria-busy', 'true');
    try {
      if (!cache.has(cacheKey)) {
        cache.set(cacheKey, (async () => {
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Quick view request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          return doc;
        })().catch(error => { cache.delete(cacheKey); throw error; }));
      }
      const doc = await cache.get(cacheKey);
      const modal = doc.getElementById(target);
      if (!modal) throw new Error('Quick view unavailable');
      const container = root.querySelector('[data-aie-quickview-modals]') || root;
      if (!root.querySelector('#' + CSS.escape(target))) container.appendChild(modal.cloneNode(true));
      trigger.removeAttribute('aria-busy');
      trigger.click();
    } catch (_) {
      const card = trigger.closest('[data-aie-slide]');
      const link = card?.querySelector('a[href*="/products/"]');
      if (link) location.assign(link.href);
    } finally {
      trigger.removeAttribute('aria-busy');
    }
  }, true);
})();